export default __webpack_public_path__ + "static/gatsby_TOC-d835d6dc9fe364af520953d8ee5851d5.png";